import { Day } from "../../components/day";
import "./style.css";
// import eventData from "../../assets/holidays.json";
import { useEffect, useRef, useState } from "react";
import { useHttp } from "../../common/hooks/useHttp";
import env from "../../config/env";
import { useUserInfo } from "../../context/user";
import { Helmet } from "react-helmet";
import { useUsersContext } from "../../context/usersContext";
import {
  useEventData,
  useChannelOptions,
  useToneOptions,
  useImgOptions,
  useTranslateOptions,
} from "../../queries/calendar";

export interface HolidayEvent {
  date: string;
  title: string;
  content: string;
  country: string;
  event_categories: string;
  event_url?: string;
  hashtags?: string;
  emoji: string;
  image_url?: string;
}

export interface EventData {
  holidays: HolidayEvent[];
}

interface EventsByDay {
  [key: string]: HolidayEvent[];
}

interface EventsByMonth {
  [key: number]: EventsByDay;
}

function Calendar() {
  const FACEBOOK_AUTH = env.FACEBOOK_AUTH;
  const userInfo = useUserInfo()[0];
  const checkIfGhlUser = useUserInfo()[9];
  const userActiveLocation = useUserInfo()[4];
  const { agency } = useUsersContext()
  const agencyData = agency;
  const [eventsByMonth, setEventsByMonth] = useState<EventsByMonth>({});
  const containerRef = useRef<HTMLDivElement>(null);
  const { sendRequest: getSMAccounts } = useHttp();
  const { data: eventData, isLoading: loading } = useEventData();
  const [SMAccoutns, setSMAccounts] = useState<any>([]);
  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth()
  );

  useEffect(() => {
    if (userActiveLocation?.ghl) {
      getSMAccounts({
        method: 'GET',
        url: `https://services.leadconnectorhq.com/social-media-posting/${userActiveLocation?.id}/accounts`,
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${userActiveLocation?.ghl?.access_token}`,
          'Version': '2021-07-28'
        }
      },
        async (response: any) => {
          setSMAccounts(response?.results?.accounts)
        })
    }
  }, [])
  const onLoad = async () => {
    if (eventData && !loading) {
      const organizedData: EventsByMonth = {};
      const filteredHolidays = eventData?.holidays.filter((event: any) => {
        const date = new Date(event.date);
        return date.getFullYear() === currentYear; // Only include events from current year
      });
      filteredHolidays?.forEach((event: any) => {
        const date = new Date(event.date);
        const month = date.getMonth();
        const day = date.getDate().toString();

        organizedData[month] = organizedData[month] || {};
        organizedData[month][day] = organizedData[month][day] || [];
        organizedData[month][day].push(event);
      });
      // eventData?.holidays.filter((item:any) => item.year == currentYear).forEach((event: any) => {
      //   const date = new Date(event.date);

      //   // Check if the date is valid
      //   if (isNaN(date.getTime())) {
      //     return;
      //   }

      //   const month = date.getMonth();
      //   const day = date.getDate().toString();

      //   organizedData[month] = organizedData[month] || {};
      //   organizedData[month][day] = organizedData[month][day] || [];
      //   organizedData[month][day].push(event);
      // });

      setEventsByMonth(organizedData);

      setTimeout(() => {
        const specificElement = document.getElementById("focus");

        if (specificElement) {
          specificElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }, 1000);
    }
    setTimeout(() => {
      const containerElement = containerRef.current;

      // Get the specific element by ID
      const specificElement = document.getElementById("focus");

      // Check if both the container and specific element exist
      if (containerElement && specificElement) {
        specificElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 1000);
  };

  const { data: socialoptions = [{ name: "", description: "" }] } = useChannelOptions();
  const { data: toneoptions = [{ name: "", description: "" }] } = useToneOptions();
  const { data: imgoptions = [{ name: "", description: "" }] } = useImgOptions();
  const { data: translateoptions = [{ name: "", description: "" }] } = useTranslateOptions();


  // Get the current year and month
  const currentDate = new Date();
  // const currentYear = currentDate.getFullYear();
  const years = [2024, 2025];
  const [currentYear, setCurrentYear] = useState(2025);



  const handleNextYear = () => {
    const currentIndex = years.indexOf(currentYear);
    if (currentIndex < years.length - 1) {
      setCurrentYear(years[currentIndex + 1]); // Move to next year in the array
    }
  };

  // Handle previous year (left arrow)
  const handlePreviousYear = () => {
    const currentIndex = years.indexOf(currentYear);
    if (currentIndex > 0) {
      setCurrentYear(years[currentIndex - 1]); // Move to previous year in the array
    }
  };
  useEffect(() => {
    onLoad();

  }, [eventData, currentYear]);

  const renderDays = () => {
    const daysInMonth = new Date(currentYear, selectedMonth + 1, 0).getDate();

    return Array.from({ length: daysInMonth }, (_, i) => {
      const dayDate = new Date(currentYear, selectedMonth, i + 1);
      const day = dayDate.toISOString().split("T")[0];

      const events =
        eventsByMonth[selectedMonth] && eventsByMonth[selectedMonth][i + 1]
          ? eventsByMonth[selectedMonth][i + 1]
          : [];

      return (
        <>
          {events.length > 0 ? (
            <div className="loader_animate_Remove loader_remove text_remove">
              <Day
                key={i}
                date={dayDate}
                events={events}
                socialopt={socialoptions}
                tonesopt={toneoptions}
                translateopt={translateoptions}
                imagesoption={imgoptions}
                SMAccoutns={SMAccoutns}
                agency={agencyData}
              />
            </div>
          ) : (
            <div className="loader_animate" style={{ justifyContent: "left", padding: "0" }}>
              <Day
                key={i}
                date={dayDate}
                events={[]}
                socialopt={[]}
                tonesopt={[]}
                translateopt={[]}
                imagesoption={[]}
                SMAccoutns={[]}
                agency={agencyData}
              />

            </div>
          )}

          <hr />
        </>
      );
    });
  };

  const handleMonthClick = (month: number) => {
    setSelectedMonth(month);
  };

  const renderMonthTabs = () => {
    const months = Array.from({ length: 12 }, (_, i) => i);

    return months.map((month) => (
      <div
        key={month}
        className={`monthTabsItem pb-2 ${selectedMonth === month ? "activeTab" : ""
          }`}
        onClick={() => handleMonthClick(month)}
      >
        <h2>
          {new Date(2022, month, 1).toLocaleString("en-US", { month: "short" })}
        </h2>
      </div>
    ));
  };


  return (
    <div className="p-5 m-auto position-relative extraPadding">
      <Helmet>
        <title>{agencyData?.Customization?.celender_m_title ? agencyData?.Customization?.celender_m_title : 'Content Calendar'}</title>


      </Helmet>
      <div className="calendarWrapper" ref={containerRef} style={{ background: '#fff', padding: '10px' }}>
        <div id="month-bar">
          <div className="year-selector">
            <button onClick={handlePreviousYear} className="arrow-button" style={{ visibility: currentYear === years[0] ? 'hidden' : 'visible' }}>&lt;</button>
            <h1 className="year mb-5">{currentYear}</h1>
            <button onClick={handleNextYear} className="arrow-button" style={{ visibility: currentYear === years[years.length - 1] ? 'hidden' : 'visible' }}>&gt;</button>
          </div>
          <div className="monthTabs w-[90%] m-auto flex justify-between">
            {renderMonthTabs()}
          </div>
          <h2 className="fullMonth">
            {new Date(2022, selectedMonth, 1)
              .toLocaleString("en-US", {
                month: "long",
              })
              .toUpperCase()}
            {/* {currentDate.toLocaleString("en-US", { month: "long" }).toUpperCase()} */}
          </h2>
        </div>
        {renderDays()}
      </div>
    </div>
  );
}

export default Calendar;
